<div class="zn-form" [formGroup]="form">
  <fieldset>
    <div class="row">
      <div class="col-12">
        <div class="form-control-container">
          <label class="form-label" for="deactivationReasonId">
            {{ `${entityResource}::Entity.Stand.DeactivationReason` | abpLocalization }}
            <span class="form-label-required">*</span>
          </label>
          <zn-single-select
            id="deactivationReasonId"
            [options]="reasonOptions()"
            [showSearch]="true"
            formControlName="deactivationReasonId"
            [errorEntityKey]="`${localizationResource}::DefaultErrorRequired`"
            [localizationResource]="localizationResource"
            [openUp]="false"
          >
          </zn-single-select>
          @if (fieldInvalid('deactivationReasonId')) {
            <small class="invalid-feedback d-block">
              {{ `${localizationResource}::DefaultErrorRequired` | abpLocalization }}
            </small>
          }
        </div>
      </div>
    </div>
  </fieldset>
</div>